import React, { useState } from "react";
import emailjs from "emailjs-com";

const BannerForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    movingDate: "",
    movingSize: "",
    movingFrom: "",
    fromFloor: "Ground Floor",
    movingTo: "",
    toFloor: "Ground Floor",
    additionalServices: [],
    message: "",
    agreeToTerms: false,
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox" && name === "additionalServices") {
      const updatedServices = checked
        ? [...formData.additionalServices, value]
        : formData.additionalServices.filter((service) => service !== value);
      setFormData({ ...formData, additionalServices: updatedServices });
    } else if (type === "checkbox" && name === "agreeToTerms") {
      setFormData({ ...formData, agreeToTerms: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.agreeToTerms) {
      setError("Please agree to the terms before submitting.");
      return;
    }
    // Replace these with your EmailJS details
    const serviceID = "service_hfvngne";
    const templateID = "template_3lkvgaz";
    const publicKey = "rJNK0ksZE4RAY84v5";

    emailjs
      .send(serviceID, templateID, formData, publicKey)
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          setSubmitted(true);
          setError(null);
          // Reset form
          setFormData({
            name: "",
            email: "",
            phone: "",
            movingDate: "",
            movingSize: "",
            movingFrom: "",
            fromFloor: "Ground Floor",
            movingTo: "",
            toFloor: "Ground Floor",
            additionalServices: [],
            message: "",
            agreeToTerms: false,
          });
        },
        (err) => {
          console.error("FAILED...", err);
          setError("Failed to send your enquiry. Please try again later.");
        }
      );
  };

  return (
    <div>
      <h6>Enquiry Form</h6>
      {submitted && <p className="messShw" style={{ color: "green" }}>Your enquiry has been sent successfully!</p>}
      {error && <p className="messShw" style={{ color: "red" }}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-lg-6">
            <input
              className="form-control form-control-sm"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Name.."
              required
            />
          </div>
          <div className="col-lg-6">
            <input
              className="form-control form-control-sm"
              type="text"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email.."
              required
            />
          </div>
          <div className="col-lg-6">
            <input
              className="form-control form-control-sm"
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Phone.."
              required
            />
          </div>
          <div className="col-lg-6">
            <input
              className="form-control form-control-sm"
              type="date"
              name="movingDate"
              value={formData.movingDate}
              onChange={handleChange}
              placeholder="Moving Date.."
              required
            />
          </div>
          <div className="col-lg-12">
            <input
              className="form-control form-control-sm"
              type="text"
              name="movingSize"
              value={formData.movingSize}
              onChange={handleChange}
              placeholder="Moving Size.."
            />
          </div>
          <div className="col-lg-6">
            <input
              className="form-control form-control-sm"
              type="text"
              name="movingFrom"
              value={formData.movingFrom}
              onChange={handleChange}
              placeholder="Moving From.."
            />
          </div>
          <div className="col-lg-6">
            <select
              className="form-control form-control-sm"
              name="fromFloor"
              value={formData.fromFloor}
              onChange={handleChange}
            >
              <option>Ground Floor</option>
              <option>2</option>
              <option>3</option>
              <option>4+</option>
            </select>
          </div>
          <div className="col-lg-6">
            <input
              className="form-control form-control-sm"
              type="text"
              name="movingTo"
              value={formData.movingTo}
              onChange={handleChange}
              placeholder="Moving To.."
            />
          </div>
          <div className="col-lg-6">
            <select
              className="form-control form-control-sm"
              name="toFloor"
              value={formData.toFloor}
              onChange={handleChange}
            >
              <option>Ground Floor</option>
              <option>2</option>
              <option>3</option>
              <option>4+</option>
            </select>
          </div>
          <div className="col-lg-12">
            <label>Additional Service</label>
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="packing"
                name="additionalServices"
                value="Packing"
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="packing">
                Packing
              </label>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="grandPiano"
                name="additionalServices"
                value="Grand Piano"
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="grandPiano">
                Grand Piano
              </label>
            </div>
            {/* Add other additional service options similarly */}
          </div>
          <div className="col-lg-12">
            <input
              className="form-control form-control-sm"
              type="text"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Message.."
            />
          </div>
          <div className="col-lg-12">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="agreeToTerms"
                name="agreeToTerms"
                checked={formData.agreeToTerms}
                onChange={handleChange}
                required
              />
              <label className="form-check-label" htmlFor="agreeToTerms">
                By checking this box, you agree to receive text messages from Cali Handy Moving. ...
              </label>
            </div>
          </div>
          <div className="col-lg-12">
            <button type="submit" className="custom-btn">
              Send
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default BannerForm;
